export default function init2DArray<T>(rows: number, cols: number = 0): T[][] {
  const a = new Array<Array<T>>(rows);
  for (let i = 0; i < rows; i++) {
    a[i] = new Array<T>(cols);
  }
  return a;
}
